import React from 'react';
import classNames from 'classnames';

// Todo: Properly migrate all of these types from Vanilla JS to TypeScript.
interface ColProps {
  granola?: any;
  children?: React.ReactNode;
  chonky?: any;
  xs?: any;
  md?: any;
  sm?: any;
  lg?: any;
  mdOffset?: any;
  [key: string]: any; // Any other props
}

const Col = ({
  granola,
  children,
  chonky,
  xs,
  sm,
  md,
  lg,
  mdOffset,
  ...props
}: ColProps) => (
  <div
    {...props}
    className={classNames({
      [`col-md-offset-${mdOffset}`]: mdOffset,
      [`col-xs-${xs}`]: xs,
      [`col-sm-${sm}`]: sm,
      [`col-md-${md}`]: md,
      [`col-lg-${lg}`]: lg,
      'col-chonky': chonky,
      'col-granola': granola,
    })}
  >
    {children}
  </div>
);

export default Col;
